// Func = limiting Scope for this file
var lastScrollTop = 0
;;(function () {
  $(document).ready(function () {
    // Main Nav Dropdown
    $('#primary-nav li').hover(
      function () {
        $(this).addClass('hover')
        $('ul.submenu', this).fadeIn(200)
      },
      function () {
        $(this).removeClass('hover')
        $('ul.submenu', this).fadeOut(200)
      },
    )

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true]
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())
      if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
        DATE_STYLE[1] = 'highlight-top'
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = 'highlight'
      } else {
        DATE_STYLE[1] = ''
      }
      return DATE_STYLE
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd'
    $('#CheckIn').datepicker({
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker('getDate')
        let newDate = new Date(getDate.getTime())
        newDate.setDate(newDate.getDate() + 3)
        $('#CheckOut').datepicker('setDate', newDate)
        $('#CheckOut').datepicker('option', 'minDate', selectedDate)
      },
    })
    $('#CheckOut').datepicker({
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
    })

    // focusParent - Add class for focus element
    const FOCUS_ELEMENTS$1 = ['#email-signup_FNAME', '#email-signup_LNAME', '#email-signup_email_address', '.form-module .form-module__field input']
    const FOCUS_CLASS_NAME$1 = 'focus'

    const focusParent = () => {
      FOCUS_ELEMENTS$1.forEach((element) => {
        let inputs = document.querySelectorAll(element)
        if (inputs === null) return null

        let parent_element

        inputs.forEach((input) => {
          input.addEventListener('focus', function (event) {
            event.preventDefault()

            parent_element = input.parentElement
            if (parent_element === null) return null

            parent_element.classList.add(FOCUS_CLASS_NAME$1)
          })

          input.addEventListener('blur', function (event) {
            if (input.classList.contains('datepicker')) return null

            if (input.value !== '') return null

            event.preventDefault()

            parent_element = input.parentElement
            if (parent_element === null) return null

            parent_element.classList.remove(FOCUS_CLASS_NAME$1)
          })
        })
      })
    }

    focusParent()
  })

  window.onload = function () {
    scrollW()
    window.addEventListener('scroll', function () {
      scrollW()
    })
  }

  const HEADER_BTN = document.querySelector('.js-open-booking')
  HEADER_BTN.addEventListener('click', function () {
    let header_form = document.querySelector('.header-form')
    header_form.classList.toggle('active')
    if (header_form.classList.contains('active')) {
      HEADER_BTN.textContent = 'Close'
    } else {
      HEADER_BTN.textContent = "Let's start planning"
    }
  })
})()

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById('header').classList.contains('down')) {
        document.getElementById('header').classList.add('down')
        document.getElementById('header').classList.remove('up')
      }
    } else {
      // upscroll code
      if (!document.getElementById('header').classList.contains('up')) {
        document.getElementById('header').classList.add('up')
        document.getElementById('header').classList.remove('down')
      }
    }
  } else {
    if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
      document.getElementById('header').classList.remove('up')
      document.getElementById('header').classList.remove('down')
    }
  }
  lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}
